/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RenewalLinkedPolicyDto } from './RenewalLinkedPolicyDto';
export type RenewalListItemDto = {
    id: string;
    renewalNumber: string;
    policyId: string;
    policyReference: string;
    renewedPolicyId?: string | null;
    renewedPolicyReference?: string | null;
    renewedPolicyStatus?: RenewalListItemDto.renewedPolicyStatus | null;
    renewedPolicyStartDate?: string | null;
    renewedPolicyExpiryDate?: string | null;
    renewedPolicy?: RenewalLinkedPolicyDto | null;
    clientId: string;
    clientName: string;
    renewalType: RenewalListItemDto.renewalType;
    workflowStatus: RenewalListItemDto.workflowStatus;
    renewalDate: string;
    currentPremium?: number | null;
    newPremium?: number | null;
    premiumDifference?: number | null;
    assignedAdviserId?: string | null;
    assignedAdviserName?: string | null;
    createdAt: string;
    updatedAt: string;
    currentRisks?: Array<Record<string, any>> | null;
    newRisks?: Array<Record<string, any>> | null;
    /**
     * Local combined-quote id for this renewal modification flow (if created).
     */
    renewalQuoteId?: string | null;
    /**
     * Status of the linked renewal quote, when present.
     */
    renewalQuoteStatus?: RenewalListItemDto.renewalQuoteStatus | null;
    /**
     * Payment frequency of the source policy.
     */
    paymentFrequency?: RenewalListItemDto.paymentFrequency | null;
    /**
     * Payment method of the latest invoice on the source policy.
     */
    paymentMethod?: RenewalListItemDto.paymentMethod | null;
};
export namespace RenewalListItemDto {
    export enum renewedPolicyStatus {
        SAVED = 'SAVED',
        ISSUED = 'ISSUED',
        VALID = 'VALID',
        EXPIRED = 'EXPIRED',
        ENDED = 'ENDED',
        CANCELLED = 'CANCELLED',
        DECLINED = 'DECLINED',
        SUPERSEDED = 'SUPERSEDED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        QUOTED = 'QUOTED',
    }
    export enum renewalType {
        AUTOMATIC = 'AUTOMATIC',
        MANUAL = 'MANUAL',
    }
    export enum workflowStatus {
        PENDING = 'PENDING',
        AWAITING_CLIENT_RESPONSE = 'AWAITING_CLIENT_RESPONSE',
        CONFIRMED_NO_CHANGE = 'CONFIRMED_NO_CHANGE',
        REQUEST_CALLBACK = 'REQUEST_CALLBACK',
        PENDING_AMENDMENTS = 'PENDING_AMENDMENTS',
        AWAITING_UPDATED_PRICING = 'AWAITING_UPDATED_PRICING',
        UPDATED_TERMS_RECEIVED = 'UPDATED_TERMS_RECEIVED',
        PRICING_FINALISED = 'PRICING_FINALISED',
        SENT_TO_CLIENT = 'SENT_TO_CLIENT',
        AWAITING_PAYMENT = 'AWAITING_PAYMENT',
        RENEWED_SUCCESSFULLY = 'RENEWED_SUCCESSFULLY',
        LAPSED = 'LAPSED',
        LOST = 'LOST',
        INSURER_REVIEW = 'INSURER_REVIEW',
    }
    /**
     * Status of the linked renewal quote, when present.
     */
    export enum renewalQuoteStatus {
        DRAFT = 'DRAFT',
        QUOTED = 'QUOTED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        CANCELLED = 'CANCELLED',
        BOUND = 'BOUND',
        DECLINED = 'DECLINED',
    }
    /**
     * Payment frequency of the source policy.
     */
    export enum paymentFrequency {
        WEEKLY = 'WEEKLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
    /**
     * Payment method of the latest invoice on the source policy.
     */
    export enum paymentMethod {
        DIRECT_DEBIT = 'DIRECT_DEBIT',
        CREDIT_CARD = 'CREDIT_CARD',
        BANK_TRANSFER = 'BANK_TRANSFER',
        OTHER = 'OTHER',
        PREMIUM_FUNDING = 'PREMIUM_FUNDING',
    }
}

